module.exports = __webpack_public_path__ + "img/icon_logout.7166f4ce.svg";